module.exports = __webpack_public_path__ + "static/media/ecom.e3b0935e.png";